import { NgModule, Optional, SkipSelf, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TbAuthInterceptor } from '@tb/auth';
import { AppErrorHandler } from './error-handler/app-error-handler.service';
import { HttpErrorInterceptor } from './http-interceptors/http-error.interceptor';
import { NotificationService } from './services/notification.service';
import { AccountService } from './services/account.service';
import { ModelService } from './services/model.service';
import { LoginService } from './services/login.service';
import { ComponentCommunicationService } from './services/component-communication.service';
import { RolesService } from './services/roles.service';
import { WorkFlowService } from './services/work-flow.service';
import { AuthenticatorService } from './services/authenticator.service';

const CORE_SERVICES = [
    NotificationService,
    AccountService,
    ModelService,
    LoginService,
    ComponentCommunicationService,
    RolesService,
    WorkFlowService,
    AuthenticatorService,
];

@NgModule({
    declarations: [],
    imports: [
        // angular
        CommonModule,
        HttpClientModule,
    ],
    providers: [
        CORE_SERVICES,
        { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: TbAuthInterceptor, multi: true },
        { provide: ErrorHandler, useClass: AppErrorHandler },
    ],
})
export class CoreModule {
    constructor(
        @Optional()
        @SkipSelf()
        parentModule: CoreModule
    ) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import only in AppModule');
        }
    }
}
